<template>
    <div class="draw-layer">
        <div class="bg-01">
            <div class="top">
                <div class="logo"><img src="../../assets/images/draw/logo.png" alt=""></div>
                <div class="back"><a target="_blank" href="http://fmz.ourgame.com/"><img src="../../assets/images/draw/back.png" alt=""></a></div>
            </div>
            <!-- <div class="bg-light animated fadeIn"></div>
            <div class="content banner">
                <div class="banner-pic animated fadeInDown"></div>
                <div class="banner-font animated bounceIn"></div>
            </div> -->
        </div>
        <div class="bg-02">
            <div class="con account">
                <div class="left-part">
                    <div class="p-con">
                        <p>活动时间: <br>7月13日至7月19日 </p>
                        <p>活动专服: 龙余仙岛 </p>
                        <p>活动规则：</p>
                        <div class="rule">
                            <ul>
                                <li>
                                    
                                    <p>1）开服前，仙友们每天可获得1次抽奖机会（当日24点清零，不可累加）</p>
                                </li>
                                <li>
                                    
                                    <p>2）每日参与将会获得额外境界礼包奖励</p>
                                </li>
                                <li>
                                    
                                    <p>3）累计参与抽奖3次可获得境界礼包“初窥”、累计参与抽奖6次可获得境界礼包“大乘”、累计参与抽奖10次可获得境界礼包“成圣”。</p>
                                </li>
                                <li>
                                    
                                    <p>4）境界礼包中获得的道具“幻海锦绸”收集10份即可合成永久时装“澜歌幻海”</p>
                                </li>
                                <li>
                                    
                                    <p>5）所有奖励将于开服后统一发放至绑定的角色邮箱</p>
                                </li>
                                <li>
                                    
                                    <p>6）恶意刷奖行为将被永久封停账号</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right-part">
                    <div class="r-con">
                        <div v-if="isBind">
                            <div class="close"><a href="http://passport.ourgame.com/lzgamelogout!webhall.do?nexturl=http://fmz.ourgame.com/activity/index.html/#/online">退出</a></div>
                            <div class="info">
                                <p>角色名：{{this.roleInfo.roleName}}</p>
                                <p>所属大区：盘古大陆</p>
                                <p>活动专服: 龙余仙岛 </p>
                            </div>
                            <ul>
                                <li class="animate-pictrue bind3">
                                    <router-link tag="a" target="_blank" :to="{ name: 'Online'}"></router-link>
                                </li>
                            </ul>
                        </div>
                        <ul v-if="unBind">
                            <li class="animate-pictrue bind1" @click="bindRole"><a href="javascript:void(0)"></a></li>
                            <li class="animate-pictrue bind2"><a target="_blank" href="http://fmz.ourgame.com/contents/22/26.html"></a></li>
                            <li class="animate-pictrue bind3">
                                <router-link tag="a" target="_blank" :to="{ name: 'Online'}"></router-link>
                            </li>
                        </ul>
                        <ul v-if="isLogin">
                            <li class="animate-pictrue btn1"><a target="_blank" href="http://passport.ourgame.com/passportlogin.do?from=ourgame&nexturl=http://fmz.ourgame.com/activity/index.html#/luckyDraw"></a></li>
                            <li class="animate-pictrue btn2"><a target="_blank" href="http://id.ourgame.com/regist.do?third_company=fumozhuan"></a></li>
                            <li class="animate-pictrue btn3"><a target="_blank" href="http://fmz.ourgame.com/contents/22/26.html"></a></li>
                            <li class="animate-pictrue btn4">
                                <router-link tag="a" target="_blank" :to="{ name: 'Online'}"></router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-03">
            <div class="con">
                <lucky-spin @awardsResult="getAwardResult" @bindAccount="goBindAccount" :loginStatus="loginStatus"></lucky-spin>
            </div>
        </div>
        <div class="bg-04">
            <div class="content">
                <footer>
                    <p>积极健康的游戏心态是健康游戏的开端，本游戏故事情节设置紧凑，请您合理控制游戏时间，避免沉溺游戏影响生活，注意自我保护，防范网络陷阱。<br>
网络文化经营许可证　京网文[2018]5376-415号 软著登字第1387887号 新广出审【2016】881号<br>
网络游戏出版物号ISBN 978-7-89988-744-8 沪新出科数【2016】301号 网站备案号: <a target="_blank" href="https://beian.miit.gov.cn/">京ICP备09074391号-2</a>
                    </p>
                </footer>
            </div>
        </div>
        <el-dialog
        title="绑定角色"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
            <div class="pop-con">
                <p>活动大区：盘古大陆</p>
                 <p>活动专服: 龙余仙岛 </p>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
                    <el-form-item label="" prop="roles">
                        <el-select v-model="ruleForm.roles" placeholder="请选择角色">
                            <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="createRole('ruleForm')">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../api/api'
import luckySpin from '@/components/LuckySpin';
export default {
    data() {
        return {
            dialogVisible: false,
            ruleForm: {
                roles: '',
            },
            rules: {
                roles: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ],
            },
            // 角色信息
            roleInfo: {},
            // 角色list
            roleList: [],
            // 已绑定状态
            isBind: false,
            unBind: false,
            // 登录状态
            isLogin: false,
            loginStatus: '',
        }
    },
    components: {
        luckySpin
    },
    mounted() {
        // 获取登录状态
        this.getLoginStatus();
    },
    methods: {
        /**
         * 获取登录状态
         */
        getLoginStatus() {
            let data = {};
            api.isLogined(data).then(res=>{
                if(res.data.result == 0) {
                    // 向子组件传值登录状态
                    this.loginStatus = 'notLogin';
                    this.isLogin = true;
                    this.isBind = false;
                    this.unBind = false;
                    // 用户未登录
                    // this.$message.error(res.data.message);
                } else {
                    this.getBindStatus();
                    this.getRoleData();
                    // 向子组件传值登录状态
                    this.loginStatus = 'login';
                }
            }).catch(res=>{})
        },
        /**
         * 获奖结果，更新我的奖品
         */
        getAwardResult(data) {
            console.log(data, '获奖结果');
        },
        goBindAccount(data) {
            this.bindRole();
        },
        /**
         * 获取绑定状态
         */
        getBindStatus() {
            let data = {};
            api.getBindRoleInfo(data).then(res=>{
                if(res.data.result == 1) {
                    // 已绑定角色
                    this.isLogin = false;
                    this.isBind = true;
                    this.unBind = false;
                    this.roleInfo = res.data.data;
                } else if(res.data.result == -1) {
                    // 未绑定角色
                    this.isLogin = false;
                    this.isBind = false;
                    this.unBind = true;
                    this.dialogVisible = true;
                } else if(res.data.result == 0) {
                    // 用户未登录
                    this.isLogin = true;
                    this.isBind = false;
                    this.unBind = false;
                    // this.$message({
                    //     message: res.data.message,
                    //     type: 'warning'
                    // });
                }
            }).catch(res=>{})
        },
        /**
         * 获取角色list
         */
        getRoleData() {
            let data = {};
            api.getRoleList(data).then(res=>{
                if(res.data.result == 1) {
                    // 获取角色list成功，给roleList赋值
                    this.roleList = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
        /**
         * 绑定账号
         */
        bindRole() {
            this.dialogVisible = true;
            // 获取角色list
            this.getRoleData();
        },
        /**
         * 绑定角色
         */
        createRole(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = {
                        roleName: this.ruleForm.roles
                    };
                    api.bindRole(data).then(res=>{
                        if(res.data.result == 1) {
                            // 关闭弹窗
                            this.dialogVisible = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            // 绑定成功更新获取用户状态接口
                            this.getBindStatus();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch(res=>{})
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
        },
    }
}
</script>
<style lang="scss">
    .pop-img img{
        width: 200px;
        height: auto;
    }
    .el-tooltip__popper{
        padding: 6;
    }
    .el-tooltip__popper.is-dark{
        background: $color-blue2 !important;
    }
    .popper__arrow{
        border-bottom-color: #54b9dd !important;
    }
    .popper__arrow::after{
        border-bottom-color: $color-blue2 !important;
    }
.draw-layer{
    .el-dialog{
        background-color: $color-blue3;
        .el-dialog__header{
            padding: 5px 10px;
            background-color: $color-blue4;
            border-bottom: 2px solid $color-blue1;
            span{
                color: $color-white;
            }
        }
        .el-dialog__headerbtn{
            top: 10px;
        }
        .el-dialog__body{
            padding: 10px 20px;
            .el-form-item{
                margin-bottom: 0;
            }
            .el-input__inner{
                width: 100%;
                background-color: $color-blue3;
                border: 1px solid $color-blue4;
                color: #8ba8af;
            }
            .el-select{
                width: 100%;
            }
        }
        .el-dialog__footer{
            padding: 0 0 20px 0;
            text-align: center;
            .el-button{
                padding: 6px 20px;
            }
            .el-button--primary{
                background-color: $color-blue4;
            }
        }
        .pop-con{
            p{
                line-height: 30px;
                font-size: 16px;
                color: $color-blue4;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.draw-layer{
    padding: 0;
    .bg-01{
        background:url(../../assets/images/draw/banner.png) center top no-repeat;
        height: 781px;
        .top{
            position: fixed;
            z-index: 9;
            @include flex-space-between();
            background-color: rgba($color: $black, $alpha: .49);
            width: 100%;
            padding: 10px 0;
        }
        .bg-light{
            position: absolute;
            z-index: 2;
            background:url(../../assets/images/draw/bg-light.png) center top no-repeat;
            width: 100%;
            height: 873px;
        }
        .banner{
            position: relative;
        }
        .banner-pic{
            position: absolute;
            z-index: 1;
            background:url(../../assets/images/draw/banner-pic.png) left bottom no-repeat;
            width: 1200px;
            height: 781px;
        }
        .banner-font{
            position: absolute;
            z-index: 3;
            top: 420px;
            background:url(../../assets/images/draw/banner-font.png) center top no-repeat;
            width: 1200px;
            height: 265px;
        }
    }
    .con{
        margin: 0 auto;
        width: 900px;
    }
    .bg-02{
        position: relative;
        background:url(../../assets/images/draw/bg-02.jpg) center top no-repeat;
        height: 509px;
        .account{
            padding-top: 80px;
            @include flex-space-between();
            .left-part{
                background:url(../../assets/images/draw/bg1.png) center top no-repeat;
                width: 602px;
                height: 325px;

                .p-con{
                    padding: 20px;
                    p{
                        color: $color-white;
                        font-size: 14px;
                        line-height: 30px;
                    }
                    .rule{
                        ul{
                            li{
                                padding: 2px 0;
                                @include flex-start();
                                span{
                                    margin: 5px 15px 0 0;
                                    width: 10px;
                                    height: 10px;
                                    background-color: $color-white;
                                }
                                p{
                                    line-height: 22px;
                                }
                            }
                        }
                    }
                }
            }
            .right-part{
                margin-top: 6px;
                background:url(../../assets/images/draw/bg2.png) center top no-repeat;
                width: 249px;
                height: 317px;

                .r-con{
                    padding: 40px 15px 0 15px;
                    .close{
                        margin-top: -30px;
                        @include flex-end();
                        a{
                            border-radius: 2px;
                            border: 1px solid #3c8194;
                            width: 60px;
                            height: 30px;
                            text-align: center;
                            line-height: 30px;
                            display: block;
                            color: $color-white;
                        }
                        a:hover{
                            background-color: #3c8194;
                        }
                    }
                    .info{
                        padding: 20px 0 60px 0;
                        width: 172px;
                        margin: 0 auto;

                        p{
                            font-size: 16px;
                            color: $color-white;
                            line-height: 30px;
                        }
                    }
                    ul{
                        li{
                            margin: 0 auto 9px auto;
                            @include sprite-icon();
                            width: 172px;
                            height: 50px;
                            a{
                                width: 172px;
                                height: 50px;
                                display: block;
                            }
                        }
                        .bind1{
                            background-position: 0 0;
                        }
                        .bind2{
                            background-position: 0 -72px;
                        }
                        .bind3{
                            background-position: 0 -143px;
                        }
                        .btn1{
                            background-position: -200px 0;
                        }
                        .btn2{
                            background-position: -200px -72px;
                        }
                        .btn3{
                            background-position: -200px -143px;
                        }
                        .btn4{
                            background-position: -200px -212px;
                        }
                    }
                }
            }
        }
    }
    .bg-03{
        background:url(../../assets/images/draw/bg-03.jpg) center top no-repeat;
        height: 653px;
    }
    .bg-04{
        background:url(../../assets/images/draw/bg-04.jpg) center top no-repeat;
        height: 191px;
        footer{
            padding: 30px 100px;
            p{
                font-size: 12px;
                color: #b3aea5;
                text-align: center;
                line-height: 26px;
            }
            a{
                color: $color-yellow;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/special/LuckyDraw.vue